// extracted by mini-css-extract-plugin
export default {"homePage":"Home_homePage__xbOoK"};